import React from 'react';
import type {HeadingProps} from '@tempo/core';
import {type StackProps, Text, VStack} from '@tempo/core';
import {LandingHeading} from '@tempo/landing';

export function highlightText(text: string): string {
	return `<span class="highlight">${text}</span>`;
}

export type TitleDescriptionProps = {
	title: string;
	detail?: React.ReactNode;
	mainTitle?: string;
	titleAs?: HeadingProps['as'];
} & StackProps;
export const TitleDescription: React.FC<TitleDescriptionProps> = ({
	title,
	detail,
	mainTitle,
	titleAs = 'h1',
	children,
	...stackProps
}) => {
	const description: React.ReactNode = detail ?? (children as React.ReactNode);

	return (
		<VStack
			px="spacing.l"
			spacing="spacing.s"
			textAlign="center"
			w="100%"
			{...stackProps}
		>
			{mainTitle && (
				<Text
					variant="subtitle.m.default"
					color="text.neutral.secondary.default"
				>
					{mainTitle}
				</Text>
			)}

			<LandingHeading as={titleAs} data-testid="page-header-text">
				{title}
			</LandingHeading>
			{description && typeof description === 'string' ? (
				<Text
					variant="body.default.regular"
					color="text.neutral.secondary.default"
					sx={{
						'> .highlight': {
							color: 'text.neutral.primary.default',
						},
					}}
					dangerouslySetInnerHTML={{__html: description}}
				/>
			) : (
				description
			)}
		</VStack>
	);
};
